export { BannerSeverity, BannerSize, BannerV2, BannerVariant } from "./BannerV2"
export type { BannerV2Props } from "./BannerV2"
